/**
 * The 3D logo's spin timing, shared by Logo3D (which runs the spin) and
 * LogoAnimation (which decides whether the arrival spin can still finish in
 * time). Its own module so LogoAnimation can read it without importing
 * Logo3D, which would pull three.js into main.js.
 */

/** One spin. */
export const SPIN_MS = 3000;

/** The frame window that has to outlast a spin. */
export const WINDOW_MS = SPIN_MS + 250;

/**
 * DWEB-193 + DWEB-83: the ARRIVAL spin must END by this point on the page's
 * clock (ms after navigation start), or it does not happen.
 *
 * e2e/mainthread.spec.js reads the page from 5 s after load. Since DWEB-193
 * the 3D logo mounts after load + idle, and with the avatar launcher also
 * loading, its arrival spin ran into that window — 3 frames from the
 * react-three-fiber chunk, measured on the first gate run of the change. The
 * same lesson as the avatar launcher's intro (v6.5.1): a lazy chunk's bounded
 * arrival window is anchored to the page's clock, not to its mount. A spin
 * that cannot finish in time is skipped; the logo appears at rest and still
 * spins on hover, focus, click, and on scrolling back into view.
 */
export const ARRIVAL_DEADLINE_MS = 4500;
